import Vue from "vue";
import VueRouter from "vue-router";
import { TokenService } from "@/api/storage";
import { initialize } from "@/api";
import Store from "../store";
import { getLoginRouteFromRole } from "@/mixins/LogoutMixin";

Vue.use(VueRouter);

const routes = [
  {
    path: "/home/:user/:language?",
    name: "home",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Home.vue"),
    meta: {
      displayName: "displayName.home",
      requiresAuth: false,
    },
  },
  {
    path: "/home-admin/:user/:language?",
    name: "homeAdmin",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/HomeAdmin.vue"),
    meta: {
      displayName: "displayName.homeAdmin",
      requiresAuth: false,
    },
  },
  {
    path: "/auth-pessoa/:user/:language?",
    name: "homeUser",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Onboarding.vue"),
    meta: {
      displayName: "displayName.homeUser",
      requiresAuth: false,
    },
  },
  {
    path: "/pagina-nao-encontrada",
    name: "notFound",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/NotFound.vue"),
    meta: {
      displayName: "displayName.notFound",
      requiresAuth: false,
    },
  },
  {
    path: "/pagina-sem-autenticacao",
    name: "notAuth",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/NotAuth.vue"),
    meta: {
      displayName: "displayName.notFound",
      requiresAuth: false,
    },
  },
  {
    path: "/onboarding/:user/:language?",
    name: "onboarding",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/HomeUser.vue"),
    meta: {
      displayName: "displayName.onboarding",
      requiresAuth: false,
    },
  },
  {
    path: "/auth-empresa/:user/:language?",
    name: "onboardingAdmin",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/OnboardingAdmin.vue"),
    meta: {
      displayName: "displayName.onboardingAdmin",
      requiresAuth: false,
    },
  },
  {
    path: "/pagina-sem-permissao",
    name: "withoutPermission",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/WithoutPermission.vue"),
    meta: {
      displayName: "displayName.notFound",
      requiresAuth: false,
    },
  },
  {
    path: "/submissao-case/:language?",
    name: "submitCasePublic",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SubmitCase.vue"),
    meta: {
      displayName: "Submissão case - Exclusive Lounge",
      requiresAuth: false,
    },
  },
  {
    path: "/transparencia-dados",
    name: "transparency",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Transparency.vue"),
    meta: {
      displayName: "displayName.transparency",
      requiresAuth: true,
      title: "Exclusive Lounge",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    next("/pagina-nao-encontrada");
  } else if (to?.meta?.requiresAuth) {
    // redirect to login if the user to try acess any other route without login
    if (!TokenService.getToken()) {
      Store.dispatch("updateRouteAfterLogin", to);
      const role = (Store as any).state?.profile?.me?.role;
      next({ name: getLoginRouteFromRole(role) });
    } else {
      initialize();
      const isReturn =
        (to.name === "settingsHome" && from.name?.includes("settings")) ||
        ([
          "searchHome",
          "timelineHome",
          "readingListHome",
          "profileCLevel",
          "profileMarketing",
          "profileHome",
        ].includes(`${to.name}`) &&
          [
            "profileCLevel",
            "profileMarketing",
            "timelinePost",
            "communityHome",
            "searchTagId",
            "roundTableItems",
            "newPostRoundTable",
            "communityMembersHome",
          ].includes(`${from.name}`) &&
          (Store.state.lastItemsPost.length > 0 ||
            Store.state.lastItemsUser.length > 0));
      Store.dispatch("updateReturn", isReturn);
      if (to.name === "settingsHome" && from.name?.includes("settings"))
        Store.dispatch("updateLastRoute", from.name);
      if (from.name === "searchHome") Store.dispatch("updateFilter", "");
      if (from.name !== null && !isReturn && to.name !== "timelinePost") {
        TokenService.saveTab("0");
      }
      next();
    }
  } else {
    next();
  }
});

export default router;
